// Local copy of the styled-component subset used by InitialObservationPanel.
// Kept independent from ../doctor-console/StyledComponents so the lab module
// doesn't depend on doctor-console internals.
import React from "react";
import { styled, createTheme } from "@mui/material/styles";
import { TableCell, TableRow, TextField, Select, Autocomplete, Paper } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const theme = createTheme({
  palette: {
    defaultColor: { main: "#21cdc0" },
  },
});

const StyledSelect = styled(Select)(() => ({
  fontFamily: "Roboto, Verdana, Source Sans Pro, sans-serif",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#125386",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#125386",
  },
  "& .MuiInputBase-input": {
    fontSize: "12px",
    padding: "14px !important",
  },
}));

const StyledTextField = styled(TextField)(() => ({
  fontSize: "12px",
  "& .MuiInputBase-input": {
    fontFamily: "Roboto,Verdana,Source Sans Pro, sans-serif",
    fontSize: "12px",
    padding: "16px 14px",
  },
  "& .MuiInputLabel-root": {
    fontFamily: "Roboto,Verdana,Source Sans Pro, sans-serif",
    fontSize: "12px",
    color: "#9e9e9e",
    "&.MuiInputLabel-shrink": {
      fontSize: "1rem",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#125386",
    fontSize: "1rem",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#FDFDFD",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#125386",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#125386",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#125386",
    },
  },
  "& .MuiSelect-select": {
    height: "1.4375em",
    padding: "16px 14px",
  },
}));

const StyledTableCellHistory = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0E588E",
    color: theme.palette.common.white,
    fontSize: 13,
    fontWeight: 600,
    border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    fontWeight: 500,
    color: "#000",
    borderBottom: "1px solid #E0E0E0",
  },
  padding: "8px 12px",
}));

const StyledTableRowHistory = styled(TableRow)(() => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledPaper = styled(Paper)(() => ({
  fontFamily: "Roboto, Verdana, Source Sans Pro, sans-serif",
  fontSize: "12px",
}));

function StyledAutocomplete(props) {
  return (
    <Autocomplete
      PaperComponent={({ children }) => <StyledPaper>{children}</StyledPaper>}
      {...props}
    />
  );
}

export {
  theme,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledAutocomplete,
};
